import Vue from 'vue';
import AuthModule from './main.vue';
import { $Cookies } from '@/utils';

const authModuleConstructor = Vue.extend(AuthModule);
let instance;

const initInstance = () => {
  instance = new authModuleConstructor({
    el: document.createElement('div')
  });
  instance.visible = false;
};

const authModule = function (options) {
  if (Vue.prototype.$isServer) return;
  const uid = $Cookies.get('uid');
  if (uid && typeof uid === 'string' && uid.trim().length >= 8) {
    return;
  }

  if (!instance) {
    initInstance();
  } else {
    instance.visible = true;
  }

  if (instance.visible) {
    document.body.appendChild(instance.$el);
    Vue.nextTick(() => {
      instance.visible = true;
      instance.$type = options.$type;
    });
  }

};

authModule.SignIn = () => {
  return authModule({
    $type: 'SignIn'
  });
};

authModule.Register = () => {
  return authModule({
    $type: 'Register'
  });
};

authModule.close = () => {
  instance.visible = false;
};


export default authModule;
